import React from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-admin';
import {AddCircleOutline} from '@material-ui/icons';
import {FormControlLabel, Switch, FormHelperText} from '@material-ui/core/';
import {useTranslation} from 'react-i18next';
import CampaignFilterRow from '../campaign/CampaignFilterRow';
import {
    dripCampaignChange,
    dripCampaignSetFilters
} from '../../actions/dripCampaignActions';

const createEmptyFilter = () => ({
    type: 'attribute',
    filter: 'contains',
    attribute: '',
    value: '',
    campaign: '',
    link: '',
});

const DripCampaignFilters = ({enableFilters, filters: rows, onToggle, onUpdateFilter}) => {
    const {t} = useTranslation();

    const addFilterHandler = () => onUpdateFilter([...rows, createEmptyFilter()]);
    const removeFilterHandler = (index) => onUpdateFilter(rows.filter((filter, i) => i !== index));
    const updateFilterHandler = (index, data) => {
        const r = [...rows];
        r[index] = {...rows[index], ...data};
        onUpdateFilter(r);
    };

    return (
        <div style={{width: '100%'}}>
            <FormControlLabel
                control={
                    <Switch
                        checked={enableFilters}
                        color={'primary'}
                        onChange={(e) => onToggle(e.target.checked)}
                    />
                }
                label={t('Filter contacts')}
            />

            {enableFilters &&
                <div>
                    <FormHelperText>{t('drip.filters.send_time_hint')}</FormHelperText>
                    {rows.map((filter, index) =>
                        <CampaignFilterRow key={index}
                                           filter={filter}
                                           index={index}
                                           onRemove={removeFilterHandler}
                                           onUpdate={updateFilterHandler}
                        />
                    )}
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <Button color={'primary'} disabled={false} aria-label={t('ADD')} label={t('ADD')} onClick={addFilterHandler}>
                            <AddCircleOutline/>
                        </Button>
                    </div>
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    enableFilters: state.dripCampaign.dripCampaign.enableFilters || false,
    filters: state.dripCampaign.dripCampaign.filters || [],
});

const mapDispatchToProps = (dispatch) => ({
    onToggle: (checked) => dispatch(dripCampaignChange('enableFilters', checked)),
    onUpdateFilter: (filters) => dispatch(dripCampaignSetFilters(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DripCampaignFilters);
